import { React, useState, useEffect } from "react";

import { Link, useLocation } from "react-router-dom";
import { Buffer } from "buffer";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Rating, Box, Typography } from "@mui/material";
import DataTable from "react-data-table-component";
import Nav from "./Nav.jsx";
import Footer from "./Footer.jsx";
import useFetch from "../Components/UseFetch.jsx";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
// import { salesOrders as SO, salesOrderLines } from '../HelperFx/datalinks.js';
import verifyToken from "../HelperFx/verifyJwt.js";
import {
  postedSalesShipment,
  postedSalesShipmentLines,
  salesComment,
} from "../HelperFx/datalinks.js";
import "./home.css";
import "./salesquote.css";
import { addCommas, cleanSpecialNaming } from "../HelperFx/common.js";
import axios from "axios";
import Swal from "sweetalert2";

const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;
const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;
const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;

const eq = " eq ";
const filter = "?$filter =";

const formatDate = (dateString) => {
  if (!dateString || dateString === "0001-01-01") return "";

  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
};

const inputList = [
  {
    type: "text",
    name: "number",
    caption: "Document No.",
    background: "lightgray",
    currency: false,
  },
  {
    type: "text",
    name: "customerNo",
    caption: "Customer No.",
    background: "lightgray",
    currency: false,
  },
  {
    type: "text",
    name: "customerName",
    caption: "Customer Name",
    background: "lightgray",
    currency: false,
  },
  {
    type: "text",
    name: "quoteNo",
    caption: "Quote No.",
    background: "lightgray",
    currency: false,
  },
  {
    type: "text",
    name: "orderNo",
    caption: "Order No.",
    background: "lightgray",
    currency: false,
  },
  {
    type: "text",
    name: "deliveryStatus",
    caption: "Delivery Status",
    background: "lightgray",
    currency: false,
  },
  {
    type: "text",
    name: "description",
    caption: "Description",
    background: "lightgray",
    currency: false,
  },
  {
    type: "text",
    name: "shipToAddress1",
    caption: "Ship To",
    background: "lightgray",
    currency: false,
  },
];

const CustomTable = () => {
  const location = useLocation();
  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, "utf8").toString(
    "base64",
  );
  const salesLinesUrl = `${REACT_DATA_URL}${postedSalesShipmentLines}${filter}documentnumber${eq}'${location.state.number}'&${REACT_APP_COMPANY_URL}`;
  // console.log('Sales Lines URL:', salesLinesUrl);
  const { data: salesReceiptLines, error } = useFetch(salesLinesUrl, token);
  // console.log('Sales Receipt Line Response:', salesReceiptLines);
  // if (error) Console.log('Sales Line Error:', error);

  const columns = [
    { name: "Type", selector: (row) => row.Type || "", sortable: true },
    {
      name: "Item",
      selector: (row) => row.no || "",
      sortable: true,
      cell: (row) => <span title={row.no}>{row.no}</span>,
    },
    {
      name: "Unit Of Measure",
      selector: (row) => row.unitOfMeasure || "",
      sortable: true,
      cell: (row) => <span title={row.unitOfMeasure}>{row.unitOfMeasure}</span>,
    },
    {
      name: "Description",
      selector: (row) => row.description || "",
      sortable: true,
      cell: (row) => <span title={row.description}>{row.description}</span>,
    },
    { name: "Qty", selector: (row) => row.quantity || 0, sortable: true },
    {
      name: "Out Standing Delivery",
      selector: (row) => row.deliveredQtyOutstanding || 0,
      sortable: true,
    },
  ];

  // Add a loading state
  if (!salesReceiptLines) return <div>Loading sales lines...</div>;

  return (
    <>
      <DataTable
        columns={columns}
        data={salesReceiptLines?.value || []}
        pagination
        noDataComponent="No sales lines found"
        customStyles={{
          rows: {
            style: {
              minHeight: "33px",
            },
          },
        }}
      />
      <div className="mt-2">
        {error && (
          <div className="text-red-500">
            Error loading sales lines: {error.message}
          </div>
        )}
      </div>
    </>
  );
};

const AccordionUsage = () => {
  const location = useLocation();
  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, "utf8").toString(
    "base64",
  );
  const jwttoken = sessionStorage.getItem("authToken");
  const { custName, userName, password } = verifyToken(jwttoken);
  const [rateNotEditable, setRateEditable] = useState(false);
  const [Rate, setRate] = useState({
    no: location.state.number,
    portalUser: userName,
    rating: 1,
    detailDescription: "",
  });

  const { data: salesReceipt } = useFetch(
    `${REACT_DATA_URL}${postedSalesShipment}?${REACT_APP_COMPANY_URL}&$filter=number eq '${location.state.number}'`,
    token,
  );
  const { data: comment } = useFetch(
    `${REACT_DATA_URL}${salesComment}?${REACT_APP_COMPANY_URL}&$filter=no eq '${location.state.number}' and portalUser eq '${userName}'`,
    token,
  );

  useEffect(() => {
    if (comment?.value?.[0]) {
      const commentLine = comment.value[0];
      setRate({
        no: commentLine.no,
        portalUser: commentLine.portalUser,
        rating: commentLine.rating,
        detailDescription: commentLine.detailDescription,
      });

      if (commentLine.portalUser === "") {
        setRateEditable(false);
      } else {
        setRateEditable(true);
      }
    }
  }, [comment]);

  // console.log('test:',salesReceipt);

  const handleRateChange = async (e) => {
    const { name, value } = e.target;
    const updatedValue = name === "rating" ? Number(value) : value;
    const updatedFormData = { ...Rate, [name]: updatedValue };
    setRate(updatedFormData);
  };

  const handleSaveEvent = async (e) => {
    e.preventDefault();

    try {
      Swal.fire({
        title: `<span style="font-size:1.1rem">You can only rate once per document? </span>`,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await axios.post(
            `${REACT_DATA_URL}${salesComment}?${REACT_APP_COMPANY_URL}`,
            Rate,
            {
              headers: {
                Authorization: `Basic ${token}`,
              },
            },
          );
          alert("Rated the Shipment Successfully");
          setRateEditable(false);
        }
      });
    } catch (error) {
      alert(error);
    }
  };

  return (
    <div className="Accord-Scrollable">
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          style={{
            color: "#333",
            margin: "3px !important",
            padding: "3px !important",
            borderBottom: "1px solid #000000",
            fontWeight: 800,
          }}
        >
          Purchase Receipt Header
        </AccordionSummary>
        <AccordionDetails>
          <form action="">
            <div className="input-row-group">
              {inputList.map((input, index) => (
                <div className="input-group" key={index}>
                  <label style={{ fontWeight: 700 }}>{input.caption}</label>
                  <input
                    type={input.type}
                    name={input.name}
                    id={input.name}
                    // value={salesReceipt?.value[0]?.[input.name] || ''}
                    value={
                      input.type === "date"
                        ? formatDate(salesReceipt?.value[0]?.[input.name])
                        : input.currency === true
                        ? addCommas(salesReceipt?.value[0]?.[input.name])
                        : cleanSpecialNaming(
                            salesReceipt?.value[0]?.[input.name] || "",
                          )
                    }
                    readOnly
                    className="input-level"
                    style={{ backgroundColor: input.background }}
                  />
                </div>
              ))}
            </div>
          </form>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel3-header"
          style={{
            color: "#333",
            borderBottom: "1px solid #000000",
            margin: 0,
            fontWeight: 800,
          }}
        >
          Rating
        </AccordionSummary>
        <AccordionDetails>
          <form action="" className="rating-container">
            <div className="d-flex gap-3">
              <Box sx={{ "& > legend": { mt: 2 } }}>
                <p>Rate the Deliveries</p>
                <Rating
                  name="rating"
                  value={Rate.rating}
                  onChange={handleRateChange}
                  disabled={rateNotEditable}
                />
              </Box>
              <Box sx={{ "& > legend": { mt: 2 } }}>
                <p>Reason for your Rating</p>
                <textarea
                  name="detailDescription"
                  value={Rate.detailDescription}
                  id=""
                  cols="55"
                  rows="3"
                  style={{ padding: "6px" }}
                  onChange={handleRateChange}
                  disabled={rateNotEditable}
                ></textarea>
              </Box>
              {!rateNotEditable && (
                <button
                  className="btn btn-sm action-btn"
                  style={{ height: "fit-content", border: "1.5px solid black" }}
                  onClick={handleSaveEvent}
                >
                  submit
                </button>
              )}
            </div>
          </form>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3-content"
          id="panel2-header"
          style={{
            color: "#333",
            borderBottom: "1px solid #000000",
            margin: 0,
            fontWeight: 800,
          }}
        >
          Purchase Receipt Lines
        </AccordionSummary>
        <AccordionDetails>
          <CustomTable />
        </AccordionDetails>
      </Accordion>

      <style>
        {`
          ::placeholder {
            color: black;
          }
        `}
      </style>
    </div>
  );
};

const SalesReceipt = () => {
  return (
    <div className="Home">
      <Nav />
      <div className="dash-main">
        <div className="squote">
          <div className="firsttab">
            <IconButton component={Link} to="/Receipts">
              <ArrowBackIcon sx={{ fontSize: "1.5rem" }} />
            </IconButton>
            <span>Purchase Receipt</span>
            {/* <div className="actions">
              <a className="btn btn-sm border-black rounded-pill px-3 mx-2 action-btn" role="button">Print</a>
            </div> */}
          </div>
          <div className="listTable my-4">
            <AccordionUsage className="Accord-Scrollable" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SalesReceipt;
